"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootParameterVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
class RootParameterVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", RootParameterVariable.settings);
    (0, _defineProperty2.default)(this, "type", "root-parameter");
    (0, _defineProperty2.default)(this, "label", "Vars Parameter");
    (0, _defineProperty2.default)(this, "description", "Use a parameter to the palette as a variable, such as a URL parameter.");
  }
  dependencies(params, resolver) {
    return resolver.paletteParameter(params.name) || params.default;
  }
  value(deps) {
    return deps;
  }
}
exports.RootParameterVariable = RootParameterVariable;
(0, _defineProperty2.default)(RootParameterVariable, "settings", {
  name: {
    type: "literal",
    valueType: "string",
    title: "Parameter Name",
    description: "Name of the parameter to load into the variable."
  },
  default: {
    type: "literal",
    valueType: "string",
    title: "Default Value",
    description: "A value to use if no parameter is provided."
  }
});
//# sourceMappingURL=RootParameterVariable.js.map